import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: "app-confirmation",
  templateUrl: "./confirmation.component.html",
})
export class ConfirmationComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit() {
    this.router.navigate(
      ["onecolumn", { outlets: { "part-center": ["formconfirmation"] } }],
      { skipLocationChange: true },
    );
  }
}
